import createReactComponent from '../createReactComponent';
var Bookmark = createReactComponent('Bookmark', [['path', {
  d: 'M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z',
  key: 'ge8jsw'
}]]);
export default Bookmark;